import type {Tree} from '../../types';

/**
 * Set a nested property in the tree
 * @param tree - The tree to set the property in
 * @param path - The path to the property
 * @param value - The value to set
 */
export function setNestedProperty(tree: Tree, path: string[], value: any) {
  let current = tree;
  path.forEach((segment, index) => {
    if (index === path.length - 1) {
      current[segment] = value;
    } else {
      if (!current[segment]) {
        current[segment] = {};
      }
      current = current[segment] as Tree;
    }
  });
}
